<template>
  <b-button
    type="submit"    
    :form="form"
    :size="size"
    class="float-right"
    :variant="variant"
    v-b-tooltip.hover
    :title="current_title"
    :disabled="!!loading"
    ><span v-if="!loading"> <slot></slot></span>
    <span v-else>
      <b-spinner small></b-spinner>
      <span v-if="loadingTextShow">{{ loadingText }}</span
      >...
    </span>
  </b-button>
</template>

<script>
export default {
  data() {
    return {
      current_title: "",
    };
  },
  watch: {
    loading(newValue, oldValue) {
      if (newValue != oldValue) {
        this.current_title = this.title;
      }
    },
    reset(newValue, oldValue) {
      if (newValue != oldValue) {
        this.loading = false;
      }
    },
  },
  props: {
    reset: { type: Boolean, default: false },
    title: { type: String, default: null },
    size: { default: "sm" },
    variant: { default: "light" },
    form: { default: null },
    loading: { type: Boolean, default: false },
    loadingTextShow: { default: true },
    loadingText: { type: String, default: "Processando" },
  },
  created() {
    if (this.title) this.current_title = this.title;
  },
};
</script>